import styled from 'styled-components';
import { ExperiencesList } from '../../experience/experiencesList';
import { media } from '../../../theme/media';

export const Container = styled.div``;

export const MarketExperiences = styled(ExperiencesList)`
  padding: 40px 24px 88px;
  ${media.tablet`
    padding: 56px 56px 88px;
  `}
`;
